export default [
  {
    header: 'sidebar.supply',
    permission: ['admin', 'accountant', 'supplier', 'chief_supplier', 'supervisor', 'financier'],
  },
  {
    title: 'sidebar.agreements',
    icon: 'FileTextIcon',
    route: 'agreements',
    permission: ['admin', 'accountant', 'supplier', 'chief_supplier', 'chief_manager', 'supervisor', 'financier'],
  },
  {
    title: 'contact.contacts',
    icon: 'UserIcon',
    route: 'contacts',
    permission: ['admin', 'chief_manager', 'accountant', 'supplier', 'chief_supplier']
  },
]
